import * as React from 'react';

export interface TitleProps {
  account: boolean;
  mode: string;
}

export const Title: React.FC<TitleProps> = ({ account, mode }) => {
  const title = React.useMemo(() => {
    switch ( mode ) {
      case 'login':
        return account ? 'Welcome Back' : 'Log In';
      case 'signup':
        return 'Sign Up';
      case 'forgot-password':
        return 'Reset Your Password';
      default:
        return '';
    }
  }, [ account, mode ]);

  return <h1 className="text-uppercase">{title}</h1>;
};
